import CustomButton from "./CustomButton";
import Dialog from "./Dialog";
import { FaTrashAlt } from "react-icons/fa";
import "../../style/scss/FormActions.scss";

export default function ConfirmDlg(props) {
  if (!props.hasOwnProperty("title")) console.error("Dlg requires a title property");
  if (!props.hasOwnProperty("children"))
    console.error("Dlg requires child elements for the contents of the dialog");
  if (!props.hasOwnProperty("onResponse")) console.error("Dlg requires onResponse property");

  const respond = (val) => {
    props.onResponse?.(val);
  };

  const deleteLabel = props.deleteLabel || "Delete";

  const footer = (
    <>
      {props.onCancel || props.cancel || props.cancelUrl || props.cancelLabel ? (
        <CustomButton
          type="button"
          variant="outlined"
          color="secondary"
          className="form-actions__cancel"
          onClick={() => respond("Cancel")}
        >
          {props.cancelLabel || "Cancel"}
        </CustomButton>
      ) : null}
      {props.ok || props.okLabel ? (
        <CustomButton type="button" variant="contained" color="primary" onClick={() => respond("OK")}>
          {props.okLabel || "OK"}
        </CustomButton>
      ) : null}
      {props.delete || props.deleteLabel ? (
        <button
          type="button"
          className="form-actions__delete"
          aria-label={deleteLabel}
          title={deleteLabel}
          onClick={() => respond(deleteLabel)}
        >
          <FaTrashAlt aria-hidden />
        </button>
      ) : null}
    </>
  );

  return (
    <Dialog open={!!props.open} onClose={() => respond("Cancel")} title={props.title} actions={footer}>
      {props.children}
    </Dialog>
  );
}
